import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  description: {
    marginTop: theme.spacing(4)
  },
  incidentList: {
    marginTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    '& li': {
      marginBottom: theme.spacing(1),
      fontSize: 14
    }
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: theme.spacing(2),
    marginTop: theme.spacing(8)
  }
}));
